import { useState, useEffect } from "react";
import { Card, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import { faSearch } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Skeleton from 'react-loading-skeleton';
import { useApi } from '../../../hooks/useApi';

export function ProductCard({ id, slug, name = '', isLoading = false }) {
  const [imageSrc, setImageSrc] = useState(null);

  const { getArticuloImage } = useApi();

  useEffect(() => {
    if (!id || isLoading) return;

    let objectUrl = null;
    
    getArticuloImage(id, 0)
      .then(data => {
        objectUrl = URL.createObjectURL(data);
        setImageSrc(objectUrl);
      })
      .catch(err => {
        console.error("Error en imagen de Card:", id, err);
        setImageSrc(null);
      });

    return () => {
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, [id, isLoading, getArticuloImage]);

  return (
    <Col className="align-self-center col-md-4 col-xs-6">
      <Card style={{ margin: '20px 0' }}>
        {!isLoading ? (
          <div className="product_image-container">
            <div
              className="product-image"
              style={{ 
                backgroundImage: imageSrc ? `url(${imageSrc})` : 'none',
                height: '200px', 
                backgroundSize: 'contain',
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'center',
                width: '100%'
              }}>
            </div>
          </div>
        ) : (
          <Skeleton height={200} />
        )}
        
        <Card.Body className="product-details">
          {!isLoading ? (
            <>
              <Card.Title className="text-center" style={{ fontSize: '1rem', height: '3rem', overflow: 'hidden' }}>
                {name}
              </Card.Title>
              <div className="text-center">
              <Link to={slug}>
                  <FontAwesomeIcon icon={faSearch} />
                </Link>
              </div>
            </>
          ) : (
            <Skeleton count={2} />
          )}
        </Card.Body>
      </Card>
    </Col>
  );
}